import { Megaphone } from "lucide-react"

import { Alert, AlertDescription } from "@/components/ui/alert"
import { config } from "@/config"

export function NoticeBanner() {
  if (!config.notice) {
    return null
  }

  return (
    <Alert>
      <Megaphone />
      <AlertDescription>{config.notice}</AlertDescription>
    </Alert>
  )
}
